import { render } from "./consult.vue?vue&type=template&id=544c1798&scoped=true"
import script from "./consult.vue?vue&type=script&lang=js"
export * from "./consult.vue?vue&type=script&lang=js"

import "./consult.vue?vue&type=style&index=0&id=544c1798&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544c1798"]])

export default __exports__